import { useQuery } from "@tanstack/react-query";
import type { ResponsiveNotePhoto } from "@rebuild/shared/models";
import { getRebuildAPI } from "@rebuild/shared/api";
import { getInternalOrgOverride } from "@/redux/actions/app.actions";
import { RESPONSIVE_NOTE_PHOTO_KEYS } from "./queryKeys";
import { responsiveNotePhotoThumbnailPollInterval } from "./thumbnailPollInterval";

const { estimatesControllerGetResponsiveNotePhotos } = getRebuildAPI();

export function useGetEstimateResponsiveNotePhotosQuery(estimateId: string | undefined) {
  return useQuery({
    queryKey: RESPONSIVE_NOTE_PHOTO_KEYS.estimate(estimateId ?? ""),
    queryFn: async (): Promise<ResponsiveNotePhoto[]> => {
      if (!estimateId) {
        throw new Error("estimateId is required");
      }

      const orgOverride = getInternalOrgOverride();
      const response = await estimatesControllerGetResponsiveNotePhotos({
        estimateId,
        ...(orgOverride ? { overrideOrganizationId: orgOverride.organizationId } : {}),
      });
      return response.data ?? [];
    },
    enabled: !!estimateId,
    refetchInterval: (query) => responsiveNotePhotoThumbnailPollInterval(query.state.data, { fastMs: 5_000, slowMs: 15_000 }),
  });
}
